import React from 'react'

function WalletIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M5 22.9039C4.45 22.9039 3.97917 22.7081 3.5875 22.3164C3.19583 21.9248 3 21.4539 3 20.9039V6.90393C3 6.35393 3.19583 5.8831 3.5875 5.49143C3.97917 5.09976 4.45 4.90393 5 4.90393H19C19.55 4.90393 20.0208 5.09976 20.4125 5.49143C20.8042 5.8831 21 6.35393 21 6.90393V9.40393H19V6.90393H5V20.9039H19V18.4039H21V20.9039C21 21.4539 20.8042 21.9248 20.4125 22.3164C20.0208 22.7081 19.55 22.9039 19 22.9039H5ZM13 18.9039C12.45 18.9039 11.9792 18.7081 11.5875 18.3164C11.1958 17.9248 11 17.4539 11 16.9039V10.9039C11 10.3539 11.1958 9.8831 11.5875 9.49143C11.9792 9.09976 12.45 8.90393 13 8.90393H20C20.55 8.90393 21.0208 9.09976 21.4125 9.49143C21.8042 9.8831 22 10.3539 22 10.9039V16.9039C22 17.4539 21.8042 17.9248 21.4125 18.3164C21.0208 18.7081 20.55 18.9039 20 18.9039H13ZM20 16.9039V10.9039H13V16.9039H20ZM16 15.4039C16.4167 15.4039 16.7708 15.2581 17.0625 14.9664C17.3542 14.6748 17.5 14.3206 17.5 13.9039C17.5 13.4873 17.3542 13.1331 17.0625 12.8414C16.7708 12.5498 16.4167 12.4039 16 12.4039C15.5833 12.4039 15.2292 12.5498 14.9375 12.8414C14.6458 13.1331 14.5 13.4873 14.5 13.9039C14.5 14.3206 14.6458 14.6748 14.9375 14.9664C15.2292 15.2581 15.5833 15.4039 16 15.4039Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  )
}

export default WalletIcon
